<template lang="pug">
  Default
    ErrorPage(:code="404")
</template>
<script>
import Default from '@/layouts/Default.vue';
import ErrorPage from '@/components/ErrorPage.vue';

export default {
  name: 'NotFound',
  components: { ErrorPage, Default },
};
</script>

<style scoped>

</style>
